import { render, staticRenderFns } from "./AppTableLimit.vue?vue&type=template&id=2604577a&scoped=true&"
import script from "./AppTableLimit.vue?vue&type=script&lang=js&"
export * from "./AppTableLimit.vue?vue&type=script&lang=js&"
import style0 from "./AppTableLimit.vue?vue&type=style&index=0&id=2604577a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2604577a",
  null
  
)

export default component.exports